import { createSlice } from '@reduxjs/toolkit';

import { fetchEmployees } from 'services';
import { RootState } from 'store';

import { EmployeesState } from './types';

const initialState: EmployeesState = {
  employees: [],
  isLoading: false,
};

const employeesSlice = createSlice({
  name: 'employees',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchEmployees.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchEmployees.fulfilled, (state, { payload }) => {
        state.employees = payload;
        state.isLoading = false;
      })
      .addCase(fetchEmployees.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { reducer: employeesReducer } = employeesSlice;

export const getAllEmployees = ({ employees }: RootState) => employees.employees;
export const getEmployeesIsLoading = ({ employees }: RootState) => employees.isLoading;
